import React, { useState, useEffect, useCallback } from 'react';
import { BUTTON_STYLES } from '@aib/uikit-react/dist/Form/Button/Button';
import * as S from './ContinueButton.styled';

interface Props {
  continueButtonId?: string;
  onClick: () => void;
  isEnabled?: boolean;
  isStepValid?: boolean;
  label?: string;
  testId?: string;
  loading?: boolean;
  ariaLabel?: string;
  buttonStyle?: BUTTON_STYLES;
  icon?: React.ReactElement;
}

function ContinueButton({
  isEnabled,
  onClick,
  label = 'Continue',
  ariaLabel,
  continueButtonId,
  ...props
}: Readonly<Props>) {
  const [isEnabledState, setIsEnabled] = useState(isEnabled);

  useEffect(() => {
    setIsEnabled(isEnabled);
  }, [isEnabled]);

  const handleClick = useCallback(() => {
    setIsEnabled(false);
    onClick();
  }, [onClick]);

  return (
    <S.ButtonContainer>
      <S.ButtonStyled
        {...props}
        label={label}
        testId={props.testId || 'continueButton'}
        fullWidth
        disabled={!isEnabledState}
        onClick={handleClick}
        isLoading={props.loading}
        id={continueButtonId}
        name="Continue to next step"
        type="submit"
        ariaLabel={ariaLabel || null}
      />
    </S.ButtonContainer>
  );
}

export default ContinueButton;
